export default "__VITE_ASSET__B6RiP6QT__"